import { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { LinearProgress } from "@mui/material";
import { Theme, ThemeProvider, responsiveFontSizes } from "@mui/material/styles";
import { ResponsiveFontSizesOptions } from "@mui/material/styles/responsiveFontSizes";

import { useOrganizationContext } from "context/OrganisationContext";
import { useRoomTemplateLoginPageContext } from "context/RoomTemplateContext";

import { createCustomTheme, enboqTheme } from "theme/custom-theme";

import { useSlugParams } from "hooks/useUrlParams";

import { ROOT_SLUG } from "constants/index";

export const ThemeWrapper = ({
	children,
	htmlFontSize,
	options,
}: {
	children: ReactNode;
	htmlFontSize?: number;
	options?: ResponsiveFontSizesOptions;
}) => {
	const { value: roomTemplate, loading } = useRoomTemplateLoginPageContext();
	const org = useOrganizationContext();
	const slug = useSlugParams();
	const { pathname } = useLocation();

	if (org.loading === false && loading === false) {
		const loginPageTheme = roomTemplate ? roomTemplate : org.value;
		let dynamicTheme: Theme =
			slug !== ROOT_SLUG && !pathname.startsWith("/admin") && !!loginPageTheme
				? createCustomTheme({ ...org.value, ...loginPageTheme }, htmlFontSize)
				: enboqTheme(htmlFontSize);

		dynamicTheme = responsiveFontSizes(dynamicTheme, options);

		return <ThemeProvider theme={dynamicTheme}>{children}</ThemeProvider>;
	}

	return <LinearProgress />;
};
